export default __webpack_public_path__ + "static/media/nguyetduchop.72934247.png";